/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Current group owner (ownerId). UI may label as Group Lead.
 */
export interface AdminGroupListItemDtoOwner { 
    /**
     * Current group owner user id (ownerId)
     */
    id: string;
    displayName: string;
    email: string;
    avatarUrl?: string;
}

